const categories_feed = [
    {
        title: {
            de: "Pferdefutter",
            nl: "Paardenvoer"
        },
        description: {
            de: `Dein Pferd ist mehr als nur ein Tier – es ist dein Partner.

Egal ob Training oder entspannter Ausritt: Jedes Pferd braucht die richtige Energie. Unser Sortiment bietet eine ausgewogene Mischung aus Nährstoffen, Vitaminen und Mineralien.

Wir beraten dich gerne individuell bei der Auswahl.`,
            nl: `Jouw paard is meer dan alleen maar een dier; het is je maatje.

Of je nu traint of ontspant: elk paard heeft behoefte aan de juiste energiebronnen.

Ons assortiment biedt een gebalanceerde mix van voedingsstoffen, vitaminen en mineralen.`
        },
        bullets: {
            de: [],
            nl: []
        },
        image: "images_general/feed_storage_1.webp"
    },
    {
        title: {
            de: "Hundefutter",
            nl: "Hondenvoer"
        },
        description: {
            de: `Dein Hund ist ein Familienmitglied. Deshalb bieten wir hochwertiges Futter für alle Lebensphasen.

Von Welpen bis Senioren – bei uns findest du passende Ernährung für jede Rasse und jedes Bedürfnis.`,
            nl: `Jouw hond is een volwaardig gezinslid.

Wij bieden voer voor elke levensfase – van puppy tot senior – afgestemd op ras en behoefte.`
        },
        bullets: {
            de: [
                "Getreidefreies Futter",
                "Hypoallergene Varianten",
                "Für empfindliche Mägen geeignet"
            ],
            nl: [
                "Graanvrij voer",
                "Hypoallergene brokken",
                "Voor gevoelige magen"
            ]
        },
        image: "images_general/dog.jpg"
    },
    {
        title: {
            de: "Katzenfutter",
            nl: "Kattenvoer"
        },
        description: {
            de: `Gib deiner Katze das Beste für ein gesundes und glückliches Leben.

Unser Katzenfutter enthält wichtige Nährstoffe für glänzendes Fell, starke Muskeln und ein gutes Immunsystem.`,
            nl: `Ontdek het beste voor jouw kat.

Ons voer bevat essentiële voedingsstoffen voor een gezonde vacht, sterke spieren en goede weerstand.`
        },
        bullets: {
            de: [
                "Trocken- und Nassfutter",
                "Für Kitten bis Senioren",
                "Unterstützt Gesundheit und Vitalität"
            ],
            nl: [
                "Brokjes en natvoer",
                "Voor kitten tot senior",
                "Ondersteunt gezondheid"
            ]
        },
        image: "images_general/cat.jpg"
    },
    {
        title: {
            de: "Taubenfutter",
            nl: "Duivenvoer"
        },
        description: {
            de: `Gutes Futter ist entscheidend für Gesundheit und Leistung deiner Tauben.

Unsere Mischungen enthalten wichtige Nährstoffe für optimale Versorgung.`,
            nl: `Goede voeding is essentieel voor je duiven.

Onze mengelingen bevatten alle belangrijke voedingsstoffen.`
        },
        bullets: {
            de: [
                "Basismischungen",
                "Sport- und Leistungsfutter",
                "Zuchtfutter",
                "Ergänzungen wie Grit und Mineralien"
            ],
            nl: [
                "Basis mengelingen",
                "Sport- en prestatievoer",
                "Kweekvoer",
                "Grit en mineralen"
            ]
        },
        image: "images_general/tauben1.jpg"
    },
    {
        title: {
            de: "Vogelfutter",
            nl: "Vogelvoer"
        },
        description: {
            de: `Breites Sortiment für Ziervögel und Wildvögel.

Geeignet für Kanarien, Papageien und Garten-Vögel.`,
            nl: `Breed aanbod voor verschillende vogelsoorten.

Geschikt voor huis- en tuinvogels.`
        },
        bullets: {
            de: [
                "Samen",
                "Erdnüsse",
                "Fettbälle",
                "Mehlwürmer"
            ],
            nl: [
                "Zaden",
                "Pinda’s",
                "Vetbollen",
                "Meelwormen"
            ]
        },
        image: "images_general/vogel.jpg"
    },
    {
        title: {
            de: "Nagerfutter",
            nl: "Knaagdiervoer"
        },
        description: {
            de: `Gesunde Ernährung ist entscheidend für Nager.

Sie unterstützt Verdauung und sorgt für natürlichen Zahnabrieb.`,
            nl: `Gezonde voeding is belangrijk voor knaagdieren.

Het ondersteunt de spijsvertering en slijtage van tanden.`
        },
        bullets: {
            de: [
                "Futter (Pellets & Mischungen)",
                "Heu",
                "Snacks",
                "Einstreu"
            ],
            nl: [
                "Brokjes of mixvoer",
                "Hooi",
                "Snacks",
                "Bodembedekking"
            ]
        },
        image: "images_general/hase.jpg"
    },
    {
        title: {
            de: "Nutztierfutter",
            nl: "Erfdieren"
        },
        description: {
            de: `Futter für Nutz- und Hoftiere wie Hühner, Schafe oder Schweine.

Abgestimmt auf die Bedürfnisse jeder Tierart und Lebensphase.`,
            nl: `Voer voor kippen, schapen en andere erfdieren.

Aangepast aan dier en levensfase.`
        },
        bullets: {
            de: [],
            nl: []
        },
        image: "images_general/nutztiere.jpg"
    },
    {
        title: {
            de: "Futterkarotten",
            nl: "Voerwortelen"
        },
        description: {
            de: `Eine gesunde Ergänzung für viele Tierarten.

Unsere Futterkarotten sind frisch, nährstoffreich und gut verdaulich.`,
            nl: `Gezonde aanvulling op het rantsoen.

Vers geoogst en rijk aan voedingsstoffen.`
        },
        bullets: {
            de: [
                "Frisch geerntet",
                "Hoher Nährwert",
                "Für viele Tierarten geeignet"
            ],
            nl: [
                "Vers geoogst",
                "Hoge voedingswaarde",
                "Voor meerdere dieren"
            ]
        },
        image: "images_general/wortel.jpg"
    }
];

export default categories_feed;
